import createIcon from '../../createIcon';

/**
 * @component @name Garage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTRDMTUuNTUyMyAxNCAxNiAxMy41NTIzIDE2IDEzQzE2IDEyLjQ0NzcgMTUuNTUyMyAxMiAxNSAxMkMxNC40NDc3IDEyIDE0IDEyLjQ0NzcgMTQgMTNDMTQgMTMuNTUyMyAxNC40NDc3IDE0IDE1IDE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTkgMTRDOS41NTIyOCAxNCAxMCAxMy41NTIzIDEwIDEzQzEwIDEyLjQ0NzcgOS41NTIyOCAxMiA5IDEyQzguNDQ3NzIgMTIgOCAxMi40NDc3IDggMTNDOCAxMy41NTIzIDguNDQ3NzIgMTQgOSAxNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04LjMzIDcuNUw3LjY3IDkuNUgxNi4zM0wxNS42NyA3LjVIOC4zM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAySDRDMi45IDIgMiAyLjkgMiA0VjIwQzIgMjEuMSAyLjkgMjIgNCAyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTE5IDE3LjY5QzE5IDE4LjE0IDE4LjY1IDE4LjUgMTguMjIgMTguNUgxNy43OEMxNy4zNCAxOC41IDE3IDE4LjE0IDE3IDE3LjY5VjE2LjVIN1YxNy42OUM3IDE4LjE0IDYuNjUgMTguNSA2LjIyIDE4LjVINS43OEM1LjM1IDE4LjUgNSAxOC4xNCA1IDE3LjY5VjExLjE5QzUuODIgOC43MiA2LjM0IDcuMTYgNi41NiA2LjVDNi42MSA2LjM0IDYuNjggNi4yMSA2Ljc1IDYuMUM2Ljc3IDYuMDggNi43OCA2LjA2IDYuOCA2LjA0QzcuMTggNS41MSA3LjcyIDUuNSA3LjcyIDUuNUgxNi4yOEMxNi4yOCA1LjUgMTYuODIgNS41MSAxNy4yIDYuMDNDMTcuMjIgNi4wNiAxNy4yMyA2LjA4IDE3LjI1IDYuMUMxNy4zMiA2LjIxIDE3LjM5IDYuMzQgMTcuNDQgNi41QzE3LjY2IDcuMTYgMTguMTggOC43MyAxOSAxMS4xOVYxNy42OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Garage = createIcon('Garage', [
  [
    'path',
    {
      d: 'M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z',
      key: 'q6tbme',
    },
  ],
  [
    'path',
    {
      d: 'M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z',
      key: '1bj5xq',
    },
  ],
  ['path', { d: 'M8.33 7.5L7.67 9.5H16.33L15.67 7.5H8.33Z', key: '1ye5e8' }],
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM19 17.69C19 18.14 18.65 18.5 18.22 18.5H17.78C17.34 18.5 17 18.14 17 17.69V16.5H7V17.69C7 18.14 6.65 18.5 6.22 18.5H5.78C5.35 18.5 5 18.14 5 17.69V11.19C5.82 8.72 6.34 7.16 6.56 6.5C6.61 6.34 6.68 6.21 6.75 6.1C6.77 6.08 6.78 6.06 6.8 6.04C7.18 5.51 7.72 5.5 7.72 5.5H16.28C16.28 5.5 16.82 5.51 17.2 6.03C17.22 6.06 17.23 6.08 17.25 6.1C17.32 6.21 17.39 6.34 17.44 6.5C17.66 7.16 18.18 8.73 19 11.19V17.69Z',
      key: '5b84px',
    },
  ],
]);

export default Garage;
